import SiafLiteApiRepository from "../../external/siafLiteApi";

class ContadorService {
  constructor() {
    this.urlBase = "/painel-controle/contador";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getById(id) {
    return new SiafLiteApiRepository(this.urlBaseEvent).getById(id);
  }

  enviarEmailContador(empresaId, email) {
    return new SiafLiteApiRepository(
      `${this.urlBaseEvent}/${empresaId}/convite-contador`
    ).post({
      email,
    });
  }
}

export default ContadorService;
